<div class="tab-container">
<mat-button-toggle-group
        name="userAccountListSelection"
        [value]="activeTab"
>
  <mat-button-toggle value="client" (click)="changeTab('client')" [class.active]="activeTab === 'client'">
    Client Accounts
  </mat-button-toggle>
  <mat-button-toggle value="system" (click)="changeTab('system')" [class.active]="activeTab === 'system'">
    System Accounts
  </mat-button-toggle>
  <mat-button-toggle value="designation" (click)="changeTab('designation')" [class.active]="activeTab === 'designation'">
    Signing Agent Designations
  </mat-button-toggle>
</mat-button-toggle-group>
</div>
